import { useState, useEffect } from 'react';
import SectionItem from 'features/dev/components/sections/SectionItem';
import SectionsList from 'features/dev/components/sections/SectionsList';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { loadList } from 'shared/api/requests';
import { BASE_URL } from 'shared/config';



function Sections(props) {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const { openModal } = useLayout();
  const { token, showToast } = useStateContext();


  const fetchSections = async () => {
    try {
      setLoading(true);
      const response = await loadList('/dashboard/admin-api/sections', '', token);
      console.log('fetched sections', response);
      setSections(response.rows);
    } catch (error) {
      showToast({ 
        title: 'Ошибка!', 
        content: error.message || 'Что-то пошло не так!',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchSections();
  }, [showToast]);
  

  return (
    <>
      {loading ? (
        <p className='flex flex-wrap'>Loading...</p>
      ) : (
        <SectionsList sections={sections} title="Страницы" selectHandler={(section) => {
          console.log('selectHandler');
          openModal({...section});
        }} />
      )}
    </>
  );
}

export default Sections;
